'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('app.canvas', {
    url: '/layout',
    template: '<configurator></configurator>'
  });

  $stateProvider.state('app.canvas.toolset-basic-layout', {
    url: '/basic',
    template: require('./basicLayout/basicLayout.html'),
    controller: 'BasicLayoutController',
    controllerAs: 'bl',
    authenticate: true
  });

  $stateProvider.state('app.canvas.toolset-background', {
    url: '/background',
    template: require('./background/background.html'),
    controller: 'BackgroundController',
    controllerAs: 'bg',
    authenticate: true
  });

  $stateProvider.state('app.canvas.toolset-border', {
    url: '/border',
    template: require('./border/border.html'),
    controller: 'BorderController',
    controllerAs: 'bd',
    authenticate: true
  });

  $stateProvider.state('app.canvas.toolset-images', {
    url: '/images',
    template: require('./images/images.html'),
    controller: 'ImagesController',
    controllerAs: 'im',
    authenticate: true
  });

  $stateProvider.state('app.canvas.toolset-text', {
    url: '/text',
    template: require('./text/text.html'),
    controller: 'TextController',
    controllerAs: 'tx',
    authenticate: true
  });

  $stateProvider.state('app.canvas.toolset-shapes', {
    url: '/shapes',
    template: require('./shapes/shapes.html'),
    controller: 'ShapesController',
    controllerAs: 'sh',
    authenticate: true
  });

  $stateProvider.state('app.canvas.toolset-finish', {
    url: '/finish',
    template: require('./finish/finish.html'),
    controller: 'FinishController',
    controllerAs: 'fn',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/configurator/configurator.routes.js